var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_214",
    x: 0,
    y: 0,
    width: 70,
    height: 70,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#adadad",
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_16_7",
    "data-name": "Component 16 \\u2013 7",
    transform: "translate(3 3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -3, -3)",
    filter: "url(#Ellipse_214)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_214-2",
    "data-name": "Ellipse 214",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(5 5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "help_FILL1_wght400_GRAD0_opsz48_1_",
    "data-name": "help_FILL1_wght400_GRAD0_opsz48 (1)",
    d: "M102.22,210.815a2.066,2.066,0,1,0-1.485-.6A2.019,2.019,0,0,0,102.22,210.815Zm-1.925-8.03h3.245a9,9,0,0,1,.357-2.613,6.476,6.476,0,0,1,2.228-2.723,9.623,9.623,0,0,0,2.42-2.8,6.457,6.457,0,0,0,.715-3.025,6.073,6.073,0,0,0-1.9-4.675,7.106,7.106,0,0,0-5.032-1.76,8.5,8.5,0,0,0-4.757,1.348,7.7,7.7,0,0,0-3,3.712l2.915,1.1a5.132,5.132,0,0,1,1.815-2.392,4.838,4.838,0,0,1,2.86-.853,4.408,4.408,0,0,1,3.025,1.017,3.324,3.324,0,0,1,1.155,2.613,4.043,4.043,0,0,1-.715,2.283,10.957,10.957,0,0,1-2.09,2.228,11.186,11.186,0,0,0-2.447,2.832A7.487,7.487,0,0,0,100.295,202.785ZM102,220a21.287,21.287,0,0,1-8.525-1.732,22.165,22.165,0,0,1-11.743-11.743,21.976,21.976,0,0,1,0-17.1,21.986,21.986,0,0,1,4.73-6.985,22.552,22.552,0,0,1,7.012-4.7,21.976,21.976,0,0,1,17.1,0,21.966,21.966,0,0,1,11.688,11.688,21.976,21.976,0,0,1,0,17.1,22.552,22.552,0,0,1-4.7,7.013,21.987,21.987,0,0,1-6.985,4.73A21.422,21.422,0,0,1,102,220Z",
    transform: "translate(-80 -176)",
    fill: "#957ba0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question-mark.19e0a2c5aeb6d9498f1c1564f2cfdb0c.svg";
export { ForwardRef as ReactComponent };